import React, { useContext, useState } from 'react'
import { CategoryItem, CategoryListProps } from './types'
import styles from './PullDown.module.css'
import { MenuArrow } from './MenuArrow'
import { StepContext } from '../../Steps/StepContainer'
import { FormValues, UserResume } from '../../Store/reducers/formReducer/types'
import { useAbTestGtm } from '../../../hooks/useAbTestGtm'

export const CategoryList = ({
    categoryData,
    formKey,
    displayFormKey,
    idField,
    clickLabelPrefix = '',
    onSelect,
}: CategoryListProps) => {
    const { dataClickLabel } = useAbTestGtm()

    const {
        handleNext,
        setFormValue,
        updateUserResume,
        setDisplayValue,
        formState,
    } = useContext(StepContext)

    const [openStates, setOpenStates] = useState<boolean[]>(
        new Array(Object.keys(categoryData).length).fill(false)
    )

    const selectedId = formState.userResumesAttributes[0][idField]

    const toggleState = (index: number) => {
        setOpenStates(prev => {
            const newStates = [...prev]
            newStates[index] = !newStates[index]
            return newStates
        })
    }

    const handleItemClick = (item: CategoryItem) => {
        onSelect?.()
        setDisplayValue(displayFormKey, item.name)

        if (Array.isArray(formKey) && formKey[0] === 'userResumesAttributes') {
            updateUserResume(0, formKey[1] as keyof UserResume, item.id)
        } else {
            setFormValue(formKey as keyof FormValues, item.id)
        }

        handleNext()
    }

    return (
        <div className={styles.menu}>
            {Object.entries(categoryData).map(([category, items], index) => {
                const prefix = `category_${clickLabelPrefix}_${index}`
                const menuId = `${prefix}_bar`
                const linksId = `${prefix}_links`

                return (
                    <div key={category} className={styles.categoryContainer}>
                        <label
                            className={styles.label}
                            htmlFor={menuId}
                            onClick={() => toggleState(index)}
                        >
                            <span>{category}</span>
                            <MenuArrow isOpen={openStates[index]} />
                        </label>
                        <input
                            className={styles.input}
                            type='checkbox'
                            id={menuId}
                            checked={openStates[index]}
                            onChange={() => {}}
                        />
                        <ul
                            className={`${styles.ul} ${openStates[index] ? styles.ulOpen : ''}`}
                            id={linksId}
                        >
                            {items.map(item => (
                                <li
                                    key={item.name}
                                    className={`${styles.list} ${openStates[index] ? styles.listOpen : ''}`}
                                >
                                    <button
                                        className={`${styles.contents} ${
                                            selectedId === item.id
                                                ? styles.selected
                                                : ''
                                        }`}
                                        onClick={() => handleItemClick(item)}
                                        data-click-label={dataClickLabel(`${clickLabelPrefix}-${item.name}`)}
                                    >
                                        {item.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                )
            })}
        </div>
    )
}
